<template>
<div>
<v-card style="width:100%;height:90px" class="secondary">
     <v-layout row wrap style="height:40px;">
      <v-flex xs10 style="padding:10px;" >
            <div class="title" style="color:white">Peer To Peer Passbook</div>
      </v-flex>
      <v-flex xs2>
      <v-btn @click="fetchstatement" icon style="float:right"><v-icon style="margin-top:0px" color="white">refresh</v-icon></v-btn>
      </v-flex>
    </v-layout>
     <v-layout row wrap style="height:40px;">
      <v-flex xs12 style="padding-top:8px" >
               <input type="text" style="float:left;width:200px;"  v-model="search"  class="search" placeholder="Search All Column" >

         <v-btn class="success searchbtn" @click="fetchstatement"> Search</v-btn>
    <v-menu
        :close-on-content-click="false"
        v-model="menu2"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date2" readonly class="search" placeholder="To Date" >
        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
      </v-menu>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date1" readonly class="search" placeholder="From Date" >
        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
      </v-menu>
      </v-flex>
    </v-layout>
</v-card>
  <v-data-table
      :headers="headers"
      :items="statementlist"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td >{{ new Date(parseInt(props.item.time)) | moment("DD-MM-YYYY, h:mm: a")}}</td>
        <td >{{ props.item.name }}</td>
        <td >{{ props.item.paidto }}</td>
        <td >{{ props.item.service }}</td>
        <td >{{ props.item.credittype }}</td>
        <td >{{ props.item.paymenttype }}</td>
        <td >{{ props.item.amount }}</td>
        <td ><v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn></td>
        <td >{{ props.item.tid }}</td>
      </template>
    </v-data-table>
      <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>

     <v-dialog v-model="viewstatus" width="400">
     <v-card >
        <v-card-title style="height:40px">
          <span class="body-2">Summary of your Order</span>
        </v-card-title>
                <v-card-text style="padding-top:0px">
               <v-layout row wrap v-for="(item,key) in summary">
                     <v-flex  xs6>
                        <v-card-text class="px-0">{{key}}</v-card-text>
                     </v-flex>
                     <v-flex  xs6>
                        <v-card-text class="px-0">{{item}}</v-card-text>
                     </v-flex>
               </v-layout>
        </v-card-text>
         </v-card>
      </v-dialog>
</div>
</template>

<script>
export default {
   data(){
      return{
         modal:false,
         date1:'',
         menu1:false,
         date2:'',
         menu2:false,
         mobile:'',
         headers: [
               { text: 'Order No', value: 'orderno',align: 'left' },
               { text: 'Load Date', value: 'time' },
               { text: 'User Name', value: 'name' },
               { text: 'Paid To', value: 'paidto' },
               { text: 'Payment Mode', value: 'service' },
               { text: 'Credit Type', value: 'credittype' },
               { text: 'Payment Type', value: 'paymenttype' },
               { text: 'Amount', value: 'amount' },
               { text: 'Status', value: 'status' },
               { text: 'TransactionID', value: 'tid' },
         ],
         dialog:false,
         viewstatus:false,
         statementlist:[],
         modal:false,
         search:'',
         summary:{}
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
      checkstatus(status){
         status = status.toLowerCase();
         if(status=="success")return "success"
         if(status=="pending")return "grey"
         if(status=="inprocess")return "warning"
         if(status=="failed")return "error"
         return "primary"
     },
     notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
        })
      },
      pushstatement(value){
            let vm = this;
            vm.statementlist = []
            for(let i =0;i<value.length;i++){
               let doc = value[i]
               let time = doc.CreatedDate.replace("/Date(","").replace(")/","")
               vm.statementlist.push({
                  amount:doc.Amount,
                  orderid:doc.CrDrId,
                  name:doc.UserName,
                  paidto:doc.PaidTo,
                  credittype:doc.CreditType,
                  time:time,
                  service :doc.PaymentMode,
                  paymenttype :doc.PaymentType,
                  status:doc.Status,
                  tid:doc.TransId
               })

            }

      },
      fetchstatement(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json',
           'getFromdate':vm.date1,
           'getTodate':vm.date2,
           'TypeName':'user',
         }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"View_Peer_To_Peer_Statement",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
   }
   },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }

}
</script>


<style scoped>
.search{
   width:150px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>

